// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SupportTicketPage.css */

.support-ticket-page {
  font-family: 'Inter', sans-serif;
  animation: fadeIn 0.5s ease-in-out;
  /* CRITICAL LAYOUT PROPERTIES ADDED HERE */
  padding: 24px;
  width: 100%;
  box-sizing: border-box;
  background-color: #F9FAFB;
  min-height: 0;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

/* EMPTY STATE */
.page--empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 60vh;
  text-align: center;
  background: white;
  border-radius: 8px;
  margin-top: 24px;
}
.page--empty img {
  width: 100px;
  margin-bottom: 24px;
  padding: 20px;
  background-color: #FEF3F2;
  border-radius: 50%;
  opacity: 0.8;
}
.page--empty h2 {
  font-size: 20px;
  font-weight: 500;
  color: #6B7280;
}

/* HEADER CONTROLS */
.page-controls-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  border-bottom: 1px solid #E5E7EB;
  flex-wrap: wrap;
  gap: 16px;
  padding-bottom: 16px;
}

/* TABS */
.filter-tabs {
  display: flex;
  gap: 24px;
}
.filter-tabs button {
  background: none;
  border: none;
  padding: 12px 4px;
  font-size: 15px;
  font-weight: 500;
  color: #6B7280;
  cursor: pointer;
  position: relative;
  transition: all 0.2s;
}
.filter-tabs button:hover {
  color: #111827;
}
.filter-tabs button.active {
  color: #F97316;
  font-weight: 600;
}
.filter-tabs button.active::after {
  content: '';
  position: absolute;
  bottom: -17px; /* Align with border-bottom of header */
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #F97316;
}

/* SEARCH & FILTER */
.search-and-filter {
  display: flex;
  align-items: center;
  gap: 12px;
}

.filter-btn {
  display: flex;
  align-items: center;
  justify-content: center;  
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  padding: 8px;
  cursor: pointer;
  background-color: #fff;
  width: 40px;
  height: 40px;
}
.filter-btn:hover {
  background-color: #F9FAFB;
}
.filter-btn img {
  height: 20px;
  width: 20px;
}

.page-search-bar {
  display: flex;
  align-items: center;
  background-color: #fff;
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  padding: 0 12px;
  width: 280px;
  height: 40px;
  box-sizing: border-box;
}
.page-search-bar:focus-within {
  border-color: #F97316;
  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.1);
}
.page-search-bar img {
  height: 16px;
  opacity: 0.5;
  margin-right: 8px;
}
.page-search-bar input {
  border: none;
  outline: none;
  font-size: 14px;
  flex-grow: 1;
  background: transparent;
  color: #374151;
}

/* TABLE */
.table-container {
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #E5E7EB;
  overflow-x: auto;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
}
.data-table {
  width: 100%;
  border-collapse: collapse;
}
.data-table th {
  background-color: #F9FAFB;
  padding: 12px 24px;
  font-size: 12px;
  font-weight: 600;
  color: #6B7280;
  text-transform: uppercase;
  text-align: left;
  border-bottom: 1px solid #E5E7EB;
}
.data-table td {
  padding: 16px 24px;
  font-size: 14px;
  color: #374151;
  border-bottom: 1px solid #F3F4F6;
  white-space: nowrap;
}
.data-table tbody tr:last-child td {
  border-bottom: none;
}
.action-icon {
  height: 18px;
  opacity: 0.7;
  cursor: pointer;
  transition: opacity 0.2s;
}
.action-icon:hover {
  opacity: 1;
}

/* BADGES */
.status-badge {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  display: inline-block;
  text-transform: capitalize;
}
.status-open { background-color: #E1EFFE; color: #1E429F; }
.status-pending { background-color: #FEF3C7; color: #92400E; }
.status-closed { background-color: #DEF7EC; color: #03543F; }

/* FOOTER */
.page-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  font-size: 14px;
  color: #6B7280;
}
.pagination-controls {
  display: flex;
  gap: 8px;
}
.pagination-controls button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border: 1px solid #E5E7EB;
  border-radius: 4px;
  width: 32px;
  height: 32px;
  cursor: pointer;
}
.pagination-controls button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* RESPONSIVE */
@media (max-width: 992px) {
  .page-controls-header {
    align-items: flex-start;
    gap: 1rem;
  }
  .search-and-filter {
    width: 100%;
  }
  .page-search-bar {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/SupportTicketPag/SupportTicketPage.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B;EACE,gCAAgC;EAChC,kCAAkC;EAClC,0CAA0C;EAC1C,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,SAAS;EACT,oBAAoB;AACtB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa,EAAE,uCAAuC;EACtD,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,UAAU;AACZ;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,0BAA0B;AAC5B;AACA,eAAe,yBAAyB,EAAE,cAAc,EAAE;AAC1D,kBAAkB,yBAAyB,EAAE,cAAc,EAAE;AAC7D,iBAAiB,yBAAyB,EAAE,cAAc,EAAE;;AAE5D,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF","sourcesContent":["/* SupportTicketPage.css */\n\n.support-ticket-page {\n  font-family: 'Inter', sans-serif;\n  animation: fadeIn 0.5s ease-in-out;\n  /* CRITICAL LAYOUT PROPERTIES ADDED HERE */\n  padding: 24px;\n  width: 100%;\n  box-sizing: border-box;\n  background-color: #F9FAFB;\n  min-height: 0;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* EMPTY STATE */\n.page--empty {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 60vh;\n  text-align: center;\n  background: white;\n  border-radius: 8px;\n  margin-top: 24px;\n}\n.page--empty img {\n  width: 100px;\n  margin-bottom: 24px;\n  padding: 20px;\n  background-color: #FEF3F2;\n  border-radius: 50%;\n  opacity: 0.8;\n}\n.page--empty h2 {\n  font-size: 20px;\n  font-weight: 500;\n  color: #6B7280;\n}\n\n/* HEADER CONTROLS */\n.page-controls-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  border-bottom: 1px solid #E5E7EB;\n  flex-wrap: wrap;\n  gap: 16px;\n  padding-bottom: 16px;\n}\n\n/* TABS */\n.filter-tabs {\n  display: flex;\n  gap: 24px;\n}\n.filter-tabs button {\n  background: none;\n  border: none;\n  padding: 12px 4px;\n  font-size: 15px;\n  font-weight: 500;\n  color: #6B7280;\n  cursor: pointer;\n  position: relative;\n  transition: all 0.2s;\n}\n.filter-tabs button:hover {\n  color: #111827;\n}\n.filter-tabs button.active {\n  color: #F97316;\n  font-weight: 600;\n}\n.filter-tabs button.active::after {\n  content: '';\n  position: absolute;\n  bottom: -17px; /* Align with border-bottom of header */\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background-color: #F97316;\n}\n\n/* SEARCH & FILTER */\n.search-and-filter {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.filter-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;  \n  border: 1px solid #E5E7EB;\n  border-radius: 6px;\n  padding: 8px;\n  cursor: pointer;\n  background-color: #fff;\n  width: 40px;\n  height: 40px;\n}\n.filter-btn:hover {\n  background-color: #F9FAFB;\n}\n.filter-btn img {\n  height: 20px;\n  width: 20px;\n}\n\n.page-search-bar {\n  display: flex;\n  align-items: center;\n  background-color: #fff;\n  border: 1px solid #E5E7EB;\n  border-radius: 6px;\n  padding: 0 12px;\n  width: 280px;\n  height: 40px;\n  box-sizing: border-box;\n}\n.page-search-bar:focus-within {\n  border-color: #F97316;\n  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.1);\n}\n.page-search-bar img {\n  height: 16px;\n  opacity: 0.5;\n  margin-right: 8px;\n}\n.page-search-bar input {\n  border: none;\n  outline: none;\n  font-size: 14px;\n  flex-grow: 1;\n  background: transparent;\n  color: #374151;\n}\n\n/* TABLE */\n.table-container {\n  background-color: #fff;\n  border-radius: 8px;\n  border: 1px solid #E5E7EB;\n  overflow-x: auto;\n  box-shadow: 0 1px 2px rgba(0,0,0,0.05);\n}\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n.data-table th {\n  background-color: #F9FAFB;\n  padding: 12px 24px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #6B7280;\n  text-transform: uppercase;\n  text-align: left;\n  border-bottom: 1px solid #E5E7EB;\n}\n.data-table td {\n  padding: 16px 24px;\n  font-size: 14px;\n  color: #374151;\n  border-bottom: 1px solid #F3F4F6;\n  white-space: nowrap;\n}\n.data-table tbody tr:last-child td {\n  border-bottom: none;\n}\n.action-icon {\n  height: 18px;\n  opacity: 0.7;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n.action-icon:hover {\n  opacity: 1;\n}\n\n/* BADGES */\n.status-badge {\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  display: inline-block;\n  text-transform: capitalize;\n}\n.status-open { background-color: #E1EFFE; color: #1E429F; }\n.status-pending { background-color: #FEF3C7; color: #92400E; }\n.status-closed { background-color: #DEF7EC; color: #03543F; }\n\n/* FOOTER */\n.page-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 20px;\n  font-size: 14px;\n  color: #6B7280;\n}\n.pagination-controls {\n  display: flex;\n  gap: 8px;\n}\n.pagination-controls button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #fff;\n  border: 1px solid #E5E7EB;\n  border-radius: 4px;\n  width: 32px;\n  height: 32px;\n  cursor: pointer;\n}\n.pagination-controls button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* RESPONSIVE */\n@media (max-width: 992px) {\n  .page-controls-header {\n    align-items: flex-start;\n    gap: 1rem;\n  }\n  .search-and-filter {\n    width: 100%;\n  }\n  .page-search-bar {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
